export const SPECIAL_TYPE = {
  PHONE: 'phone',
  DATE: 'date',
  DATE_TIME: 'date-time',
  LIST_INPUT: 'list-input',
  SELECT: 'select',
};

export const SPECIAL_TYPE_LIST = Object.values(SPECIAL_TYPE);
